<script setup lang="ts">
import { AccordionContent, AccordionContentProps } from "primevue";

defineProps<AccordionContentProps>();
</script>

<template>
  <AccordionContent
    v-bind="$attrs"
    :pt="{
      content: {
        class: '!p-0 !border-t-1 !border-gray-200',
      },
    }"
  >
    <slot />
  </AccordionContent>
</template>
